import useVisibilitySensor from '@rooks/use-visibility-sensor';
import * as React from 'react';
import { animated, useSpring } from 'react-spring';
import styled from 'styled-components';
import { useImageLoaded } from '../../utils/hooks/useImageLoaded';
import { CardFallback } from '../layout/CardFallback';
import { ImageType } from '../../../server/global/enum';
import { isExternalURL } from '../../utils/helpers/url';

const ImageStyle = styled.div`
  position: relative;
  width: 100%;
  height: 250px;
  background: rgb(20, 20, 20);
  img {
    width: 100%;
    height: 250px;
    object-fit: cover;
  }
  .pm-logo {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 60px;
    height: 60px;
    path {
      fill: rgb(232, 200, 147);
    }
  }
`;

const LogoStyle = styled.div`
  position: relative;
  width: 100%;
  height: 250px;
  background: rgb(20, 20, 20);
  img {
    width: 100%;
    height: 35%;
    object-fit: contain;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin:auto
  }
  .pm-logo {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 60px;
    height: 60px;
    path {
      fill: rgb(232, 200, 147);
    }
  }
`;

export const Image: React.FC<{ url: string; style: any; type?: string; }> = ({
  url,
  style,
  type
}) => {
  const imageRef = React.useRef<any>();
  const [imgType, setImgType] = React.useState(type);

  const { isVisible } = useVisibilitySensor(imageRef, {
    intervalCheck: false,
    scrollCheck: true,
    scrollDebounce: 30,
    resizeCheck: true,
    shouldCheckOnMount: true,
    minTopValue: -100,
    partialVisibility: true,
  });

  const { loaded, error } = useImageLoaded({
    url: url,
    visible: isVisible,
  });

  const fadeIn: any = useSpring({
    opacity: loaded ? 1 : 0,
    config: {
      duration: 200,
    },
  });

  if (imgType == ImageType.Logo) {
    return (<LogoStyle ref={imageRef}>
      {loaded && !error ? (
        <animated.img style={fadeIn} data-src={url} src={url} alt="" />
      ) : loaded ? (
        <CardFallback className="pm-logo" />
      ) : null}
    </LogoStyle>);
  }

  return (
    <ImageStyle ref={imageRef}>
      {loaded && !error ? (
        <animated.img style={fadeIn} data-src={url} src={url} alt="" />
      ) : loaded ? (
        <CardFallback className="pm-logo" />
      ) : null}
    </ImageStyle>
  );
};
